import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FileService } from '../file/file.service';

@Injectable({
  providedIn: 'root',
})
export class HandlingStepsFormService {
  fileService = inject(FileService);

  errorStore = signal<{ [key: string]: string[] }>({});
  currentStepPosition = signal<number>(1);

  reapplyErrors(
    formGroup: FormGroup,
    errorStores: { [key: string]: string[] }
  ) {
    const errors = errorStores;
    Object.keys(errors).forEach(controlName => {
      const control = formGroup.get(controlName);
      if (control) {
        control.setErrors({
          apiError: true,
          apiErrorMessage: errors[controlName],
        });
        control.markAsTouched();
        control.markAsDirty();
      }
    });
  }

  navigateToStep(
    formGroup: FormGroup,
    stepMappings: { [key: string]: number },
    stepSignals: {
      currentStepPosition: WritableSignal<number>;
      firstStep: WritableSignal<boolean>;
      secondStep: WritableSignal<boolean>;
      thirdStep: WritableSignal<boolean>;
      fourthStep: WritableSignal<boolean>;
    }
  ) {
    const controls = formGroup.controls;
    const controlNames = Object.keys(controls);

    for (const name of controlNames) {
      const control = controls[name];
      if (control.invalid || this.errorStore()[name]) {
        if (this.errorStore()[name]) {
          control.setErrors({
            apiError: true,
            apiErrorMessage: this.errorStore()[name],
          });
        }

        const step = stepMappings[name];
        if (step) {
          stepSignals.currentStepPosition.set(step);
          stepSignals.firstStep.set(step === 1);
          stepSignals.secondStep.set(step === 2);
          stepSignals.thirdStep.set(step === 3);
          stepSignals.fourthStep.set(step === 4);
        }

        this.reapplyErrors(formGroup, this.errorStore());
        break;
      }
    }
  }

  addControlErrors(
    formGroup: FormGroup,
    error: { errors: { [key: string]: string[] }; message: string }
  ) {
    const errors: { [key: string]: string[] } = error.errors;
    this.errorStore.set(errors);

    for (const [key, messages] of Object.entries(errors)) {
      // Use the original key as Angular FormGroup.get() can handle dot notation
      const control = formGroup.get(key);
      if (control) {
        control.setErrors({
          apiError: true,
          apiErrorMessage: messages[0],
        });
        control.markAsTouched();
        control.markAsDirty();
      }
    }
  }

  isStepValid(formGroup: FormGroup, controls: string[]): boolean {
    return controls.every(controlName => {
      const control = formGroup.get(controlName);
      // Skip validation for disabled controls
      if (control && control.disabled) {
        return true;
      }
      return !!control?.valid;
    });
  }
}
